const state = {
  live_status: -1,
  fromRid: -1,
  fromTid: -1,
  is_favorite: -1,
  favorite_num: -1,
  study_total_time: -1,
};
const mutations = {
  live_status(state, live_status) {
    state.live_status = live_status;
  },
  fromRid(state, fromRid) {
    state.fromRid = fromRid;
  },
  fromTid(state, fromTid) {
    state.fromTid = fromTid;
  },
  is_favorite(state, is_favorite) {
    state.is_favorite = is_favorite;
  },
  favorite_num(state, favorite_num) {
    state.favorite_num = favorite_num;
  },
  study_total_time(state, study_total_time) {
    state.study_total_time = study_total_time;
  },
};
const actions = {
  live_status: ({ commit }) => commit("live_status"),
  fromRid: ({ commit }) => commit("fromRid"),
  fromTid: ({ commit }) => commit("fromTid"),
  is_favorite: ({ commit }) => commit("is_favorite"),
  favorite_num: ({ commit }) => commit("favorite_num"),
  study_total_time: ({ commit }) => commit("study_total_time"),
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
